export const enDesign = {
  design: {
    navigationFailed: 'This page could not be loaded.',
    display: 'Display',
    actions: 'Node actions',
    background: 'Background',
    cards: 'Cards',
    general: 'General',
    solid: 'Solid',
    gradient: 'Gradient',
    image: 'Image',
    color: 'Color',
    startColor: 'Start color',
    endColor: 'End color',
    angle: 'Direction',
    flow: 'Flowing gradient',
    duration: 'Animation cycle',
    upload: 'Upload image',
    uploading: 'Uploading…',
    imageHint: 'PNG, JPEG or WebP · up to 10 MB',
    imageUrl: 'Image URL',
    filters: 'Filter',
    none: 'Original',
    soft: 'Soft',
    monochrome: 'Monochrome',
    warm: 'Warm',
    cool: 'Cool',
    brightness: 'Brightness',
    blur: 'Blur',
    overlay: 'Overlay color',
    overlayOpacity: 'Overlay strength',
    motion: 'Motion',
    still: 'Still',
    drift: 'Slow drift',
    breathe: 'Breathing light',
    glass: 'Frosted glass',
    opacity: 'Opacity',
    preview: 'Live preview',
    previewHint: 'Changes apply after saving.',
    reset: 'Reset',
    discard: 'Discard',
    more: 'More',
    uploadFailed: 'Unable to upload this image.',
    invalidImage: 'Choose a PNG, JPEG or WebP image under 10 MB.',
    imageTooLarge: 'Use a smaller image.',
    motionHint: 'Animations pause in the background and respect reduced motion.',
    emptyImage: 'Choose your background',
    advanced: 'Image link',
    saved: 'Saved',
    save: 'Save changes',
    compactDashboard: 'Nodes',
    compactUptime: 'Uptime',
    compactAdmin: 'Administration',
    compactAlerts: 'Alerts',
    smooth: 'Smooth curves',
    percentiles: 'P95 / P99',
    charts: 'Chart display',
    placeholders: 'Insert variable',
  },
}
export const zhDesign = {
  design: {
    navigationFailed: '页面加载失败，请刷新重试。',
    display: '显示',
    actions: '节点操作',
    background: '背景',
    cards: '卡片',
    general: '通用',
    solid: '纯色',
    gradient: '渐变',
    image: '图片',
    color: '颜色',
    startColor: '起始颜色',
    endColor: '结束颜色',
    angle: '渐变方向',
    flow: '流动渐变',
    duration: '动画周期',
    upload: '上传图片',
    uploading: '上传中…',
    imageHint: 'PNG、JPEG、WebP · 最大 10 MB',
    imageUrl: '图片地址',
    filters: '静态滤镜',
    none: '原图',
    soft: '柔和',
    monochrome: '黑白',
    warm: '暖色',
    cool: '冷色',
    brightness: '亮度',
    blur: '模糊',
    overlay: '蒙层颜色',
    overlayOpacity: '蒙层强度',
    motion: '动态效果',
    still: '静止',
    drift: '缓慢流动',
    breathe: '呼吸光影',
    glass: '毛玻璃',
    opacity: '不透明度',
    preview: '即时预览',
    previewHint: '保存后生效。',
    reset: '重置',
    discard: '放弃修改',
    more: '更多',
    uploadFailed: '图片上传失败。',
    invalidImage: '请选择 10 MB 以内的 PNG、JPEG 或 WebP 图片。',
    imageTooLarge: '请使用较小的图片。',
    motionHint: '后台自动暂停，并遵循系统的减少动画设置。',
    emptyImage: '选择你的背景',
    advanced: '图片链接',
    saved: '已保存',
    save: '保存修改',
    compactDashboard: '节点',
    compactUptime: '在线排行',
    compactAdmin: '管理',
    compactAlerts: '告警',
    smooth: '平滑曲线',
    percentiles: 'P95 / P99',
    charts: '图表显示',
    placeholders: '插入变量',
  },
}
